._container_k42tb_1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3; }

._cloudDarkLeft_k42tb_9 {
  position: absolute;
  top: 0;
  width: 55%;
  height: 130%;
  filter: blur(calc(max(7vw, 90px)));
  animation: _appear_k42tb_1 2.5s ease-in-out 0.5s both;
  left: 0;
  transform: scale(-1, 1) translateX(66%) scale(1.2) rotate(-9deg); }

@container animated-bg (max-width: 768px) {
  ._cloudDarkLeft_k42tb_9 {
    width: 100%;
    transform: scale(-1, 1) translateX(66%) scale(1.2) rotate(-9deg); } }
  ._cloudDarkLeftInner_k42tb_23 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #496d7a;
    background-size: cover;
    -webkit-clip-path: url(#cloud-side-clip);
            clip-path: url(#cloud-side-clip);
    will-change: transform;
    animation: _breath_k42tb_1 3s ease-in-out infinite alternate; }

._cloudDarkRight_k42tb_35 {
  position: absolute;
  top: 0;
  width: 55%;
  height: 130%;
  filter: blur(calc(max(7vw, 90px)));
  animation: _appear_k42tb_1 2.5s ease-in-out 0.5s both;
  right: 0;
  transform: translateX(62%) scale(1.2); }

@container animated-bg (max-width: 768px) {
  ._cloudDarkRight_k42tb_35 {
    display: none; } }
  ._cloudDarkRightInner_k42tb_48 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #6f6f70;
    background-size: cover;
    -webkit-clip-path: url(#cloud-side-clip);
            clip-path: url(#cloud-side-clip);
    will-change: transform;
    animation: _breath_k42tb_1 3s ease-in-out infinite alternate-reverse; }

._cloudLight_k42tb_60 {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  aspect-ratio: 1/1;
  filter: blur(50px);
  animation: _appear_k42tb_1 1.5s ease-in-out forwards; }

@container animated-bg (max-width: 768px) {
  ._cloudLight_k42tb_60 {
    right: 0;
    width: 100%;
    height: 100%;
    transform: translateX(-20%) rotate(180deg); } }
  ._cloudLightInner_k42tb_76 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(233, 240, 255, 0.5);
    background-size: cover;
    -webkit-clip-path: url(#cloud-center-clip);
            clip-path: url(#cloud-center-clip);
    will-change: transform;
    animation: _breath_k42tb_1 3s ease-in-out infinite alternate; }

@keyframes _appear_k42tb_1 {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

@keyframes _breath_k42tb_1 {
  0% {
    opacity: 0.9; }
  100% {
    opacity: 1;
    transform: scale(1.1) skewX(5deg) rotate(10deg) skewY(-5deg); } }
